import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import {
  companyLinkedin,
  companyInstagram,
  companyTwitter,
} from "utils/socialMedia";

const Footer = ({ isLoggedIn, isDarkTheme, ...props }) => {
  return isLoggedIn ? (
    <footer className="py-4" style={{ borderTop: "1px groove #4C4B56" }}>
      <Container>
        <Row>
          <Col
            xs={12}
            md={8}
            className="text-center text-md-start mt-3 mt-md-0 order-2 order-md-1"
            style={{ fontSize: "14px" }}
          >
            Copyright © 2023 Fort Investech Systems Ltd. All rights reserved
          </Col>
          <Col xs={12} md={4} className="text-right order-1 order-md-2">
            <div className="d-flex justify-content-center justify-content-lg-end">
              <a href={companyLinkedin} className="mx-3">
                <i className="bi bi-linkedin" style={{ color: "#F8F8F8" }}></i>
              </a>
              <a href={companyInstagram} className="mx-3">
                <i className="bi bi-instagram" style={{ color: "#F8F8F8" }}></i>
              </a>
              <a href={companyTwitter} className="mx-3">
                <i className="bi bi-twitter" style={{ color: "#F8F8F8" }}></i>
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  ) : (
    <footer className="py-5">
      <Container>
        <Row>
          <Col
            xs={12}
            lg={3}
            className="text-center text-lg-start mb-3 mb-lg-0"
          >
            <Logo handleClick={() => {}} isDarkTheme={isDarkTheme} />
          </Col>
          <Col
            xs={12}
            lg={6}
            className="text-center mb-3 mb-lg-0 align-content-center"
          >
            <Row className="list-unstyled d-flex justify-content-center justify-content-lg-start">
              <Col sm={12} lg={2} className="mb-3 mb-lg-0 text-center">
                <Link to="/how-it-works" className="nav-link text-nowrap">
                  How it works
                </Link>
              </Col>
              <Col sm={12} lg={2} className="mb-3 mb-lg-0">
                <Link to="/pricing" className="nav-link text-nowrap">
                  Pricing
                </Link>
              </Col>
              <Col sm={12} lg={2} className="mb-3 mb-lg-0">
                <Link to="/about-us" className="nav-link text-nowrap">
                  About Us
                </Link>
              </Col>
              <Col sm={12} lg={2} className="mb-3 mb-lg-0">
                <Link to="/contact-us" className="nav-link text-nowrap">
                  Contact Us
                </Link>
              </Col>
              <Col sm={12} lg={2} className="mb-3 mb-lg-0">
                <Link to="/blog" className="nav-link text-nowrap">
                  Blog
                </Link>
              </Col>
            </Row>
          </Col>
          <Col xs={12} lg={3} className="text-center text-lg-right">
            <div className="d-flex justify-content-center justify-content-lg-end">
              <a href={companyLinkedin} className="mx-3" target="_blank">
                <i className="bi bi-linkedin" style={{ color: "#301E67" }}></i>
              </a>
              <a href={companyInstagram} className="mx-3" target="_blank">
                <i className="bi bi-instagram" style={{ color: "#301E67" }}></i>
              </a>
              <a href={companyTwitter} className="mx-3" target="_blank">
                <i className="bi bi-twitter" style={{ color: "#301E67" }}></i>
              </a>
            </div>
          </Col>
        </Row>
        <Row className="mt-4 d-block d-lg-none">
          <Col className="text-center">
            <small>&copy; 2023 - FortInvestech Systems</small>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
